export default __webpack_public_path__ + "static/media/thumb_1.b25255de.png";